
type PlaneType = {
    d: number,
    class: string,
    rot: Array<Array<number>>,
}

export function getFloorPlane (planes: Array<PlaneType>): PlaneType {
    // Returns the ground floor plane
    return planes.filter(p => p.class === "floor").reduce((a, b) => a.d < b.d ? a : b)
}

export function getFloorIndex (planes: Array<PlaneType>): number {
    // Returns the index of the ground floor plane
    const floor = getFloorPlane(planes)
    return planes.indexOf(floor) 
}
